import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { DesktopNavBar } from '../DesktopNavBar';
import { MobileNavBar } from '../MobileNavBar';
import { ConnectedSelectSiteWithRouter } from '../SelectSite';
import { BuildingActions } from '../../store/building/actions';
import { SelectedBuilding, CategoryType, SubCategoryType, NavigationParamsType } from '../../store/building/types';
import { logo } from './assets';
import './NavBar.css';

export interface Props extends RouteComponentProps<any> {
  location: {
    search: string;
    pathname: string;
    state: string;
    hash: string;
  };
  selectedBuilding: SelectedBuilding;
  navigationParams: NavigationParamsType;
  buildingsList: SelectedBuilding[];
  setNavigationParams(category: CategoryType, subcategory: SubCategoryType): void;
  isStaff: boolean;
  isUserManager: boolean;
}

export interface State {
  activeCategory?: CategoryType;
}

export class NavBar extends Component<Props, State> {
  state = {
    activeCategory: undefined,
  };

  updateSelectedCategories = async (
    selectedCategory: CategoryType,
    selectedSubCategory: SubCategoryType,
    activeCategory?: CategoryType,
  ) => {
    // Updates redux store with updated category/subcategory
    this.props.setNavigationParams(selectedCategory, selectedSubCategory);
    this.setState((state: State) => ({
      ...state,
      activeCategory,
    }));
  };

  render() {
    const {
      selectedBuilding = {} as SelectedBuilding,
      navigationParams = {} as NavigationParamsType,
      isStaff,
      isUserManager,
    } = this.props;
    const { activeCategory } = this.state;

    return (
      <React.Fragment>
        <div className="nav-bar-placeholder" />
        <div className="nav-bar">
          <div className="nav-bar__logo-wrapper">
            <img className="nav-bar__logo" src={logo} alt="parity" />
          </div>
          <ConnectedSelectSiteWithRouter />
          <DesktopNavBar
            navigation={selectedBuilding.navigation || []}
            navigationParams={navigationParams}
            isStaff={isStaff}
            isUserManager={isUserManager}
          />
          <MobileNavBar
            utilities={selectedBuilding.navigation || []}
            activeCategory={activeCategory || undefined}
            selectedCategory={navigationParams.selectedCategory || {}}
            selectedSubCategory={navigationParams.selectedSubCategory || {}}
            onClick={this.updateSelectedCategories}
            isStaff={isStaff}
            isUserManager={isUserManager}
          />
        </div>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    buildingsList: state.buildingReducer.buildsList,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    navigationParams: state.buildingReducer.navigationParams,
    isStaff: state.profileReducer.is_staff,
    isUserManager: state.profileReducer.is_user_manager,
  };
}

const mapDispatchToProps = {
  setNavigationParams: BuildingActions.setNavigationParams,
};

const ConnectedNavBar = connect(mapStateToProps, mapDispatchToProps)(NavBar);
const ConnectedNavBarWithRouter = withRouter(ConnectedNavBar);
export { ConnectedNavBarWithRouter };
